<script setup lang="ts">
import { type SideMenuItem } from "~/composables/useChromeMenuItems";

defineProps<{
  item: SideMenuItem;
}>();
</script>

<template>
  <Copy :type="item.active.value ? 'bodyStrong' : 'body'" size="medium" :color="item.active.value ? '--color-white' : '--color-accent-300'">
    {{ item.labelText }}
  </Copy>
</template>
